import { getContactUsLink } from '../shared/UtilFunctions';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { getEnvVar } from '../utils/getEnvVar';
import { PageContent } from '@deere/fuel-react/PageContent.js';

export default function NoAccessEmployee(props) {
  const userId = props.userId;

  const goHelpDesk = () => {
    window.open(getContactUsLink(userId));
  };
  const goReqAccess = () =>
    window.open(getEnvVar('VITE_REQUEST_ACCESS') + userId);

  return (
    <PageContent
      sx={(theme) => ({
        paddingTop: theme.fuel6Tokens.JddcSpacingLarge,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      })}
    >
      <Typography component="h1" variant="h2">
        Sorry, you don't have access to this feature.
      </Typography>
      <Box
        sx={{
          fontSize: '200px',
          color: (theme) => theme.fuel6Tokens.JddcColorIconSecondary
        }}
      >
        <fuel-icon name="warning" />
      </Box>
      <Box sx={(theme) => ({ pt: theme.fuel6Tokens.JddcSpacingXLarge })}>
        <Button variant="secondary" onClick={goHelpDesk}>
          Contact Help Desk
        </Button>
        <Button
          variant="primary"
          onClick={goReqAccess}
          sx={{ marginLeft: '.5rem' }}
        >
          Request Access
        </Button>
      </Box>
    </PageContent>
  );
}
